import * as React from "react";
const SvgFiRrHouseSignal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-signal_svg__a)">
      <path
        fill="#062147"
        d="M24 7.514v6.438A4.05 4.05 0 0 1 19.952 18H15a1 1 0 1 1 0-2h4.952A2.05 2.05 0 0 0 22 13.952V7.514c0-.809-.4-1.562-1.07-2.014l-4.571-3.084a2.42 2.42 0 0 0-2.717 0L9.071 5.5a2.43 2.43 0 0 0-1.07 2.014V9a1 1 0 1 1-2 0V7.514c0-1.474.729-2.847 1.951-3.672l4.57-3.084a4.41 4.41 0 0 1 4.955 0l4.571 3.084A4.43 4.43 0 0 1 24 7.514M16 13a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zM1.5 21a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M1 16a1 1 0 1 0 0 2c2.757 0 5 2.243 5 5a1 1 0 1 0 2 0c0-3.859-3.141-7-7-7m0-5a1 1 0 1 0 0 2c5.514 0 10 4.486 10 10a1 1 0 1 0 2 0c0-6.617-5.383-12-12-12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-signal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseSignal;
